const initialState = {
  validateEmail: false
};

export default initialState;
